import * as actions from "@src/actions/index";
import { getabilitiesMenu } from '../add-ability/thunk';
import i18n from '@src/i18n';
import { message } from "@cloud/atom-ui";

// 获取已开通能力菜单
export const getMenus = (appId, dispatch) => {
  getabilitiesMenu(appId).then(res => {
    const { code, data = [] } = res;
    if (code === 200) {
      dispatch(actions.abilityMenuList({ appId, list: data }));
    } else {
      message.error(i18n.t('addAbility:getMenusFailed'));
    }
  })
};